import type { DensityPreference } from "./types";

export const DENSITY_LABELS: Record<DensityPreference, string> = {
  comfortable: "Comfortable",
  compact: "Compact"
};

export const DENSITY_DESCRIPTIONS: Record<DensityPreference, string> = {
  comfortable: "Larger text and more space between rows",
  compact: "Smaller text, more on screen at once"
};

/** Words that surface each density in the Cmd+K palette. */
const DENSITY_KEYWORDS: Record<DensityPreference, string> = {
  comfortable: "comfortable display density text size larger bigger spacing",
  compact: "compact display density text size smaller dense pro"
};

/**
 * Densities matching a palette query. They only appear once the user types
 * something related, so they never crowd the default list.
 */
export function matchDensityCommands(query: string): DensityPreference[] {
  const needle = query.trim().toLowerCase();
  if (needle.length < 2) return [];
  return (Object.keys(DENSITY_KEYWORDS) as DensityPreference[]).filter(
    (value) => DENSITY_KEYWORDS[value].includes(needle)
  );
}
